module.exports = __webpack_public_path__ + "static/img/ES.7270a462.jpg";